<template>
  <div></div>
</template>

<script type="text/javascript">
import Axios from "axios";
import Stringify from "json-stringify-safe";

export default {
  name: "rest",
  components: {},
  mixins: [],

  data() {
    return {
      requestParam: {
        force_web: false,
        url: process.env.URL_API.web,
        xToken: process.env.X_TOKEN,
        appVersion: process.env.APP_VERSION,
        service: null,
        method: null,
        encryptData: null,
        jwt: null,
        headers: null,
        loginRedirect: true,
        uploadProgress: null,
      },
    };
  },

  mounted() {},

  computed:{
    dados: {
      cache: false,
      get() {
        return this.$store.state.common.request;
      },
      set(value) {
        this.$store.dispatch("common/setRequest", value);
      },
    },
  },
  methods: {
    getUrl: function (method) {
      this.setUrl();
      return (
        this.requestParam.url +
        method +
        "?token=" +
        this.$root.$session.logged()
      );
    },

    get: function (_service, _params, _force_web) {
      _params = !_params ? "" : "?" + $.param(_params);

      this.requestParam.service = _service + _params;
      this.requestParam.force_web = _force_web;
      this.requestParam.method = "GET";

      return this.request();
    },
    post: function (_service, _params, _filters, _force_web) {
      _filters = !_filters ? "" : "?" + $.param(_filters);

      this.requestParam.service = _service + _filters;
      this.requestParam.param = _params;
      this.requestParam.force_web = _force_web;
      this.requestParam.method = "POST";

      return this.request();
    },

    put: function (_service, _params, _filters, _force_web) {
      _filters = !_filters ? "" : "?" + $.param(_filters);

      this.requestParam.service = _service + _filters;
      this.requestParam.param = _params;
      this.requestParam.force_web = _force_web;
      this.requestParam.method = "PUT";

      return this.request();
    },

    delete: function (_service, _params, _filters, _force_web) {
      _filters = !_filters ? "" : "?" + $.param(_filters);

      this.requestParam.service = _service + _filters;
      this.requestParam.param = _params;
      this.requestParam.force_web = _force_web;
      this.requestParam.method = "DELETE";

      return this.request();
    },

    open: function (_service, _params) {
      this.setUrl();

      _params = !_params ? "" : "&" + $.param(_params);

      var token = this.$root.$session.logged();

      if (token) _service += "?token=" + token + _params;

      window.open(this.requestParam.url + _service, "_blank");
    },

    cs: function (_service, _params,_target = '_top') {
      _params = !_params ? "" : "?" + $.param(_params);
        window.open(this.$root.$session.env.url_cs + _service+_params,_target);
    },

    removeStyle: function () {
      $("body").removeAttr("style");
      $("body").removeClass(
        "el-loading-parent--relative el-loading-parent--hidden"
      );
    },

    getReq() {
      var req = {
        date: null,
        hash: null,
      };

      req.date = this.$utilidade.addDate(1, null, "m");
      req.date = this.$utilidade.toDate(req.date, false, "YYYY-MM-DD HH:mm:ss");

      req.hash = this.$utilidade.toMd5(req.date + process.env.REQ_KEY);

      return this.$utilidade.base64Encode(JSON.stringify(req));
    },

    getHeaders: function (onlyeJWT) {
      var jwt = this.$root.$session.logged(),
        version = this.$root.$session.getCookie("version"),
        req = {
          date: null,
          hash: null,
        };

      if (onlyeJWT) {
        return {
          authorization: jwt ? "Bearer " + jwt : null,
        };
      }

      var headers = {
        //'X-Requested-With': 'XMLHttpRequest',
        Authorization: jwt ? "Bearer " + jwt : null,
        Version: version ? version : "null",
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF8",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET, POST, OPTIONS, PUT, DELETE",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type",
      };

      headers[process.env.REQ_NAME] = this.getReq();

      return headers;
    },

    setHeaders: function () {
      this.requestParam.headers = this.getHeaders();

      Axios.defaults.headers.common = this.requestParam.headers;
    },

    setUrl: function () {
      var 
        sub_domain = this.requestParam.force_web == true ? "web" : this.$root.$session.sub_domain,
        url = process.env.PROTOCOL + process.env.URL_API[sub_domain];

      if (process.env.NODE_ENV == "production") {
        url += "/commtrol/api/";
      }
      else
      {
        url += "/api/";
      }

      // '/api/' +

      if (sub_domain != "web") url += this.$root.$session.tenant + "/";
      // if (sub_domain != "web") url +=";

      if (sub_domain != "web")
        console.log(this.$root.$session.tenant);

      this.requestParam.url = url;

      return url;
    },

    request() {
      this.setUrl();
      this.setHeaders();
      console.log('URL API Chamada: ' + this.requestParam.url + this.requestParam.service);

      var response = {};
      this.dados = null;

      return new Promise((resolve, reject) => {
        response = { msg: "OK", status: 200, data: null };
        var promisses = [],
          self = this;

        Axios({
          method: this.requestParam.method,
          url: this.requestParam.service,
          data: this.requestParam.param,
          baseURL: this.requestParam.url,
          //timeout: 260000,
          onUploadProgress: function (progressEvent) {
            var uploadProgress = Math.floor(
              (progressEvent.loaded / progressEvent.total) * 100
            );

            if (uploadProgress == 100) {
              uploadProgress = 99;
            }

            self.requestParam.uploadProgress = uploadProgress;
          },
          onDownloadProgress: function (progressEvent) {},
        })
          .then((result) => {
            response = result.data;
            promisses.push(response);

            this.removeStyle();
            this.requestParam.uploadProgress =
              this.requestParam.uploadProgress != null ? 100 : null;

            return Promise.all(promisses).then(
              (success) => {
                resolve(success[0]);
              },
              (err) => {}
            );
          })
          .catch((err) => {
            var error = Object.assign({}, err).response;
            this.requestParam.uploadProgress =
              this.requestParam.uploadProgress != null ? 100 : null;

            if (!error) {
              error = {
                status: 500,
                msg:
                  "Não foi possível completar a requisição. Precione as teclas CTRL+F5 para recarregar a página e tente novamente.",
                data: null,
              };

              error.data = error;
            }

            if (error) {
              response = error.data;

              switch (response.status) {
                // case 400:
                //   if (response.options && response.options.data) {
                //     const h = this.$createElement;
                //     var items = [],
                //       validation_messages = response.options.data;
                //     this.$root.$dialog.alert(response.msg, "error");
                //   }

                //   break;

                case 401:
                  if(this.$route.meta.requiresAuth){
                    this.$root.$session.logout();
                  }
                  break;

                case 413:
                  response.msg = "A requisição excedeu o tamanho limite.";
                  response.data = "A requisição excedeu o tamanho limite.";
                  break;

                case 426:
                  window.location.reload(true);
                  break;

                case 429:
                  this.$root.$dialog.alert(
                    "Servico indisponível. Aguarde 5 minutos e tente novamente.",
                    "error"
                  );
                  break;
              }
            }

            promisses.push(response);

            if (
              this.requestParam.method != "GET" &&
              response.status != 200 &&
              response.status != 426 &&
              response.status != 403 &&
              response.status != 401 &&
              response.status != 404
            ) {
              this.$root.$dialog.alert(response.msg, "error");
              this.dados = response;
            }

            this.removeStyle();
  
            return Promise.all(promisses).then(
              (success) => {
                resolve(success[0]);
              },
              (err) => {}
            );
          });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// EdRequest.vue?585a4e2e